<div class="child-partners-list-container">
    <div class="child-partners-list-buttons">
      <button
        *ngIf="(userPermissions | async).partner.read_report"
        [disabled]="!(userPermissions | async)?.partner.read_report"
        mat-raised-button
        (click)="downloadReport()" class="report-button">
      <mat-icon>download</mat-icon> Pobierz raport
      </button>
  </div>
  <table mat-table [dataSource]="childPartners">

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa skrócona </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.uuid]">{{element.shortName ? element.shortName : "\<\brak nazwy\>"}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let element">
        <div *ngFor="let email of element.emails">
          <span *ngIf="email.main">{{email.address}}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef> Numer telefonu </th>
      <td mat-cell *matCellDef="let element">
        <div *ngFor="let phone of element.phones">
          <span *ngIf="phone.main">{{phone.number | phone}}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="nip">
      <th mat-header-cell *matHeaderCellDef> NIP </th>
      <td mat-cell *matCellDef="let element"> {{element.nip}} </td>
    </ng-container>

    <ng-container matColumnDef="regon">
      <th mat-header-cell *matHeaderCellDef > REGON </th>
      <td mat-cell *matCellDef="let element" > {{element.regon}} </td>
    </ng-container>

    <ng-container matColumnDef="headquartersAddress">
      <th mat-header-cell *matHeaderCellDef> Adres siedziby </th>
      <td mat-cell *matCellDef="let element">
        <app-table-address [address]="element.headquartersAddress"></app-table-address>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek)</th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="element.assetsRegional">
            {{element.assetsRegional.firstName}} {{element.assetsRegional.lastName}}
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
</div>
